import React, { useState } from 'react';
import { updateTenantInfo } from '../api/tenantApi';
import { apiFetch } from '../api/client';

export function PasswordModal({ onClose }: { onClose: () => void }) {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSave = async () => {
        setError(''); setSuccess('');
        if (!oldPassword || !newPassword || !confirm) {
            setError('Compila tutti i campi');
            return;
        }
        if (newPassword !== confirm) {
            setError('Le password non coincidono');
            return;
        }
        try {
            // Chiamata reale al backend per cambio password
            const res = await apiFetch('/api/auth/change-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ oldPassword, newPassword })
            });
            if (!res.ok) throw new Error('Cambio password fallito');
            setSuccess('Password aggiornata!');
            setTimeout(onClose, 1200);
        } catch (err: any) {
            setError('Errore salvataggio: ' + (err.message || err));
        }
    };

    return (
        <div className="modal-bg">
            <div className="modal-card">
                <h3>Modifica password</h3>
                <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                    <input type="password" placeholder="Vecchia password" autoComplete="current-password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} />
                    <input type="password" placeholder="Nuova password" autoComplete="new-password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                    <input type="password" placeholder="Conferma nuova password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} />
                    {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
                    {success && <div style={{ color: 'green', marginTop: 8 }}>{success}</div>}
                    <div className="modal-actions">
                        <button type="submit" className="btn-primary">Salva</button>
                        <button type="button" onClick={onClose} className="btn-muted">Annulla</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export function ProfileModal({ user, onClose }: { user: { name: string; email: string }; onClose: () => void }) {
    const [name, setName] = useState(user.name);
    const [email, setEmail] = useState(user.email);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSave = async () => {
        setError(''); setSuccess('');
        if (!name || !email) {
            setError('Compila tutti i campi');
            return;
        }
        try {
            // Esempio: chiamata API per modifica profilo
            await updateTenantInfo({ name, email });
            setSuccess('Dati aggiornati!');
            localStorage.setItem('user', JSON.stringify({ ...user, name, email }));
            setTimeout(onClose, 1200);
        } catch (err: any) {
            setError('Errore salvataggio: ' + (err.message || err));
        }
    };

    return (
        <div className="modal-bg">
            <div className="modal-card">
                <h3>Modifica dati gestore</h3>
                <input type="text" placeholder="Nome" value={name} onChange={e => setName(e.target.value)} />
                <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
                {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
                {success && <div style={{ color: 'green', marginTop: 8 }}>{success}</div>}
                <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                    <button onClick={handleSave} style={{ background: 'var(--secondary)', color: '#fff', border: 'none', borderRadius: '0.7rem', padding: '0.7rem 1.2rem', fontWeight: 600 }}>Salva</button>
                    <button onClick={onClose} style={{ background: '#eee', color: '#888', border: 'none', borderRadius: '0.7rem', padding: '0.7rem 1.2rem', fontWeight: 500 }}>Annulla</button>
                </div>
            </div>
        </div>
    );
}

// Stili minimi per modale (puoi spostare in CSS)
// .modal-bg { position: fixed; top:0; left:0; width:100vw; height:100vh; background:rgba(0,0,0,0.15); display:flex; align-items:center; justify-content:center; z-index:1000; }
// .modal-card { background:#fff; border-radius:1rem; box-shadow:0 4px 16px rgba(67,97,238,0.12); padding:2rem; min-width:320px; display:flex; flex-direction:column; gap:1rem; }
